import { Id } from '@/infra/id'
import { GetTxfJobRequest } from '@taxfyle/api-internal/internal/txf_pb'
import { type JobsApi } from '@/features/jobs/api/job-api'
import { collection } from '@/infra/collection'
import { TxfJob } from './TxfJob'
import { mapTxfJobProtoToProps } from './txf-job-mappers'
import { onRpcNotFoundReturnNull } from '@/utils/grpc-util'

export class TxfJobStore {
  readonly txfJobs = collection({
    getDataId: (d) => d.jobId,
    getModelId: (m) => m.jobId,
    create: () => new TxfJob(),
  })

  constructor(private readonly _api: JobsApi) {}

  /**
   * Gets the cached TXF job of a job.
   *
   * @param jobId
   */
  forJob(jobId: Id) {
    return this.txfJobs.get(Id.assert(jobId))
  }

  async fetchTxfJob(jobId: Id, signal?: AbortSignal) {
    const request = new GetTxfJobRequest().setJobId(Id.assert(jobId))

    const response = await this._api.txf
      .getTxfJob(request)
      .catch(onRpcNotFoundReturnNull)
    signal?.throwIfAborted()

    return response ? this.txfJobs.set(mapTxfJobProtoToProps(response)) : null
  }
}
